import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';

import { accountBunja } from '@flipster/r230522/original/account';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getFlipsterConfigsV1Key, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { leverageRestrictionBunja } from '../../../../margin-bonus/leverage-restriction.state';
import { authBunja } from '../../../auth/state';

export const leverageRestrictionPopupBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { userAtom } = bunja.use(authBunja);
  const { v2AccountAtom } = bunja.use(accountBunja);
  const { leverageRestrictionAtom } = bunja.use(leverageRestrictionBunja);

  const hasShownPopupBaseAtom = atomWithDefault((get) => {
    const user = get(userAtom);
    if (!user) return false;
    const storageKey = getFlipsterConfigsV1Key(user.userId, 'skipLeverageLimitRestrictPopup');
    return getLocalStorage(storageKey) ?? false;
  });

  const shouldShowLeverageLimitRestrictPopupAtom = atom(
    (get) => {
      const user = get(userAtom);
      if (!user) return false;

      const { isMaxInitLeverageRestricted } = get(leverageRestrictionAtom);
      const hasShown = get(hasShownPopupBaseAtom);

      return isMaxInitLeverageRestricted && !hasShown;
    },
    (get, set, action: 'close' | 'reset') => {
      const user = get(userAtom);
      if (!user) return;

      const storageKey = getFlipsterConfigsV1Key(user.userId, 'skipLeverageLimitRestrictPopup');

      if (action === 'close') {
        setLocalStorage(storageKey, true);
        set(hasShownPopupBaseAtom, true);
        return;
      }

      if (action === 'reset') {
        setLocalStorage(storageKey, false);
        set(hasShownPopupBaseAtom, false);
      }
    },
  );

  const shouldResetStorageAtom = atom((get) => {
    const user = get(userAtom);
    if (!user) return false;

    const { isMaxInitLeverageRestricted } = get(leverageRestrictionAtom);
    const hasShown = get(hasShownPopupBaseAtom);

    return !isMaxInitLeverageRestricted && hasShown;
  });

  bunja.effect(() => {
    function resetPopup() {
      const shouldReset = store.get(shouldResetStorageAtom);
      if (!shouldReset) return;
      store.set(shouldShowLeverageLimitRestrictPopupAtom, 'reset');
    }
    resetPopup();
    const unsub = store.sub(v2AccountAtom, resetPopup);
    return unsub;
  });

  return {
    leverageRestrictionAtom,
    shouldShowLeverageLimitRestrictPopupAtom,
  };
});

leverageRestrictionPopupBunja.debugLabel = 'leverageRestrictionBunja';
